import { render, staticRenderFns } from "./c-base-dialog.vue?vue&type=template&id=71db606a&scoped=true&"
import script from "./c-base-dialog.vue?vue&type=script&lang=js&"
export * from "./c-base-dialog.vue?vue&type=script&lang=js&"
import style0 from "./c-base-dialog.vue?vue&type=style&index=0&id=71db606a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71db606a",
  null
  
)

export default component.exports